export default "__VITE_ASSET__CmZWrx9G__"